import PropTypes from 'prop-types';
import React from 'react';
import { hasPrivilege } from '../../../hocs/withPrivileges';
import useAuthentication from '../../../hooks/useAuthentication';
import NumberField from '../NumberField';
import ReadonlyNumberField from '../ReadonlyNumberField';

PrivilegedNumberField.propTypes = {
    sufficientPrivileges: PropTypes.arrayOf(PropTypes.string).isRequired,
    sufficientReadPrivileges: PropTypes.arrayOf(PropTypes.string),
    emptyReadonlyValue: PropTypes.string,
};

PrivilegedNumberField.defaultProps = {
    sufficientReadPrivileges: null,
    emptyReadonlyValue: null,
};

function PrivilegedNumberField(props) {
    const {
        sufficientPrivileges,
        sufficientReadPrivileges,
        emptyReadonlyValue,
        ...rest
    } = props;
    const { userPrivileges } = useAuthentication();
    const canWrite = hasPrivilege(userPrivileges, sufficientPrivileges);
    const canRead = !canWrite && (sufficientReadPrivileges === null || hasPrivilege(userPrivileges, sufficientReadPrivileges));
    return (
        canWrite
            ? (
                <NumberField {...rest} />
            )
            : (
                canRead && (
                    <ReadonlyNumberField
                        emptyValue={emptyReadonlyValue}
                        {...rest}
                    />
                )
            )
    );
}

export default PrivilegedNumberField;
